export default "__VITE_ASSET__682470fa__"